export const CHAT_PANEL_WIDTH_MIN = 320;
export const CHAT_PANEL_WIDTH_MAX = 700;
export const CHAT_PANEL_WIDTH_DEFAULT = 380;

export function clampChatPanelWidth(width: number): number {
  return Math.min(CHAT_PANEL_WIDTH_MAX, Math.max(CHAT_PANEL_WIDTH_MIN, width));
}
